import { MainContentArea, ContentHeader, } from "melco-ui";
import { useTranslation } from "react-i18next";
import { UsersList } from "../../components/users/UsersList";
import { UserAddProfileButton } from "../../components/users/UserAddProfileButton";
import { useState } from "react";

// Add Translation
export const Users: React.FC = () => {
  const { t } = useTranslation();


  const [isAddProfileDrawerOpen, setIsAddProfileDrawerOpen] = useState<boolean>(false);

  const setIsAddProfileDrawerOpenFunction = (v: boolean) => {
    setIsAddProfileDrawerOpen(v);
  }

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("main_menu.users")}
          extra={
            <UserAddProfileButton
              setIsAddProfileDrawerOpenAction={setIsAddProfileDrawerOpen}
            />
          }


        />
      }
    >
      <UsersList
        isAddProfileDrawerOpen={isAddProfileDrawerOpen}
        setIsAddProfileDrawerOpenFunction={setIsAddProfileDrawerOpenFunction}
      />



    </MainContentArea>
  );
};
